import React from 'react';
import c from 'classnames';

import Button from '../Button';

const FormattedLink = ({ link }) => {
  if (link === undefined || link.size <= 0) return null;

  const regExp = /button--(\w+)/i;

  return (
    <div className={c('u-multiple-buttons', 'u-multiple-buttons--horizontal', 'u-margin--top--6')}>
      {link.map((field) => {
        const linkClass = field.getIn(['options', 'attributes', 'class']);
        const type = regExp.test(linkClass) ? regExp.exec(linkClass)[1] : 'link';

        const href = field.get('alias') || field.get('uri');

        const isResetCookieLink = href === '#reset-cookies';

        return (
          <Button
            type={type}
            key={`link:${field.get('title')}`}
            href={href}
            onClick={() => {
              if (isResetCookieLink) {
                if (window.gtag) {
                  window.gtag('consent', {
                    ad_storage: 'denied',
                    analytics_storage: 'denied',
                    functionality_storage: 'denied',
                    personalization_storage: 'denied',
                    security_storage: 'granted',
                  });
                }

                // Revoke all cookies that we have access to.
                document.cookie.split(';').forEach((cookie) => {
                  const eqPos = cookie.indexOf('=');
                  const name = cookie.substring(0, eqPos).trim();
                  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
                });

                // Reload the page to invalidate/remove the cookie.
                window.location.reload();
              }
            }}
          >
            {field.get('title')}
          </Button>
        );
      })}
    </div>
  );
};

export default FormattedLink;
